import {
    ArrowLeftIcon,
    CloseIcon,
    Dialog,
    Flex,
    Loader,
    Skeleton,
    Text,
    Tooltip,
} from "@fluentui/react-northstar";
import React, { useState } from "react";
import {
    TimerRegular,
    WarningFilled,
    CommentMultipleFilled,
} from "@fluentui/react-icons";
import styled from "styled-components";
import StripedTypeLeaveWeek from "../StripedTypeLeaveWeek";

import moment from "moment";
import CellDetail from "./CellDetail";
import EditSlotDialogContent from "./EditSlotDialogContent";
import { useQuery } from "react-query";
import { _api_get_slot_detail_by_date } from "../../api";
import Toast from "../../../../components/Alerts";

const renderSlot = ({ slot, day_hours_count, day }) => {
    return (
        <Flex fill>
            {/* {slot.leave_name !== null && <Text content="Co" />} */}
            {!slot.hours_count ? (
                <Flex styles={{ padding: "2px 4px" }} fill>
                    <StripedTypeLeaveWeek
                        background_color={slot?.leave_color + "50"}
                        leave_name={slot?.leave_name}
                        striped_color={slot?.leave_color}
                        hours={slot?.hours_count}
                    />
                </Flex>
            ) : (
                <Flex column fill hAlign="center" vAlign="center">
                    <Flex vAlign="center" gap="gap.small">
                        {day?.exist_edited_shifts_from_badge && (
                            <Tooltip
                                content="Timbrage modifié "
                                pointing
                                subtle={false}
                                trigger={
                                    <BgIcon
                                        bgColor={"#FBF6D9"}
                                        color={"#FFAA44"}
                                    >
                                        <TimerRegular />
                                    </BgIcon>
                                }
                                unstable_disableTether="all"
                            />
                        )}
                        {day?.comment && (
                            <Tooltip
                                content={day?.comment}
                                pointing
                                subtle={false}
                                trigger={
                                    <BgIcon
                                        bgColor={"#E8EBFA"}
                                        color={"#424242"}
                                    >
                                        <CommentMultipleFilled />
                                    </BgIcon>
                                }
                                unstable_disableTether="all"
                            />
                        )}

                        {!day ? (
                            <Skeleton animation="wave">
                                <Skeleton.Line width="20px" />
                            </Skeleton>
                        ) : !day?.pause_respected ? (
                            <Tooltip
                                content="Temps de pause non respecté"
                                pointing
                                subtle={false}
                                trigger={
                                    <BgIcon
                                        bgColor={"#FCF4F6"}
                                        color={"#C4314B"}
                                    >
                                        <WarningFilled color="red" />
                                    </BgIcon>
                                }
                                unstable_disableTether="all"
                            />
                        ) : null}
                    </Flex>
                    {/* second test  */}
                    {slot?.shifts?.length ? (
                        <Tooltip
                            onClick={() => console.log({ slot })}
                            position="after"
                            align="top"
                            subtle={false}
                            pointing
                            content={
                                <Flex column gap="gap.medium">
                                    <Text content="Créneaux du jour" />
                                    <Flex column gap="gap.smaller">
                                        {slot?.shifts?.map((el) => {
                                            const start_time_formatted =
                                                el?.start_time
                                                    ?.replaceAll(":", "h")
                                                    .slice(0, -3);
                                            const end_time_formatted =
                                                el?.end_time
                                                    ?.replaceAll(":", "h")
                                                    .slice(0, -3);
                                            return (
                                                <Flex>
                                                    <Text
                                                        content={`${start_time_formatted} - ${end_time_formatted}`}
                                                    />
                                                </Flex>
                                            );
                                        })}
                                    </Flex>
                                </Flex>
                            }
                            trigger={
                                <CellText content={`${slot?.hours_count} h`} />
                                // here the trigger of the one cell
                            }
                        />
                    ) : (
                        <CellText content={`${day_hours_count} h`} />
                    )}
                </Flex>
            )}
        </Flex>
    );
};

const Cell = ({ el: day, WeekData }) => {
    const [openDialog, setOpenDialog] = useState(false);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [configToast, setConfigToast] = useState({
        visible: false,
        content: "",
        level: "danger",
    });
    const isNotWorking = day?.type?.value === 3;
    const isWorking = day?.type?.value === 0;
    const isHoliday = day?.type?.value === 1;
    const isWeeklyRest = day?.type?.value === 4;
    const isLeave = day?.type?.value === 2;
    const comment = day?.comment;
    const slots = day?.slots;
    const slots_len = slots?.length ?? 0;

    const ClickedDate = moment(day?.date).format("DD MMMM");

    const {
        data: slot_data,
        isLoading: isLoadingSlotData,
        refetch: refetchSlotData,
    } = useQuery(
        ["timeline::getSlotDataByDate", day?.id],
        (data) => {
            const params_day_id = data.queryKey[1];
            return _api_get_slot_detail_by_date(params_day_id);
        },
        {
            enabled: openDialog === true,
            onSuccess: (data) => {},
            onError: (error) => {
                console.log({ error });
            },
        }
    );

    const displayData = () => {
        refetchSlotData();
        setOpenDialog(true);
    };

    return (
        <Flex>
            <Toast
                onStatusChange={() =>
                    setConfigToast({
                        visible: false,
                        content: "",
                        level: "danger",
                    })
                }
                level={configToast.level}
                content={configToast.content}
                visible={configToast.visible}
            />
            <DialogStyle
                open={openDialog}
                onCancel={() => setOpenDialog(false)}
                header={
                    <Flex vAlign="center" gap="gap.medium">
                        {showEditDialog && (
                            <ArrowLeftIcon
                                onClick={() => setShowEditDialog(false)}
                            />
                        )}
                        <Text content={`${day?.name} ${ClickedDate}`} />
                    </Flex>
                }
                headerAction={{
                    icon: <CloseIcon outline />,
                    title: "Close",
                    onClick: () => {
                        setOpenDialog(false);
                        setShowEditDialog(false);
                    },
                }}
                content={
                    showEditDialog ? (
                        <EditSlotDialogContent
                            setConfigToast={setConfigToast}
                            refetchSlotData={refetchSlotData}
                            dayId={day?.id}
                            slot_data={slot_data}
                            showEditDialog={showEditDialog}
                            setShowEditDialog={setShowEditDialog}
                            setOpenDialog={setOpenDialog}
                            openDialog={openDialog}
                        />
                    ) : (
                        <CellDetail
                            setConfigToast={setConfigToast}
                            refetchSlotData={refetchSlotData}
                            slot_data={slot_data}
                            isLoadingSlotData={isLoadingSlotData}
                            showEditDialog={showEditDialog}
                            setShowEditDialog={setShowEditDialog}
                        />
                    )
                }
                trigger={
                    <OneCell
                        onClick={day?.id !== 0 ? displayData : null}
                        vAlign="end"
                        hAlign="center"
                        space="between"
                        column
                        $is_holiday={isHoliday}
                    >
                        <Flex hAlign="center" vAlign="center" fill>
                            {isNotWorking && (
                                <Flex
                                    fill
                                    hAlign="center"
                                    styles={{ padding: "8px" }}
                                >
                                    <CellText content="-" />
                                </Flex>
                            )}
                            {isHoliday && slots_len === 0 && (
                                <Flex
                                    vAlign="center"
                                    fill
                                    hAlign="center"
                                    styles={{
                                        marginTop: "-32px",
                                        padding: "8px",
                                        backgroundColor: "#FBF6D9",
                                        outline: "1px solid #FBF6D9",
                                        borderRadius: "2px ",
                                    }}
                                >
                                    <CellText content="Férié" />
                                </Flex>
                            )}
                            {isWeeklyRest && slots_len === 0 && (
                                <Flex
                                    fill
                                    hAlign="center"
                                    styles={{ padding: "8px" }}
                                >
                                    <CellText content="-" />
                                </Flex>
                            )}
                            {isHoliday &&
                                slots_len > 0 &&
                                day?.slots?.map((slot) => {
                                    return renderSlot({
                                        slot,
                                        day_hours_count: slot?.hours_count,
                                        day,
                                    });
                                })}

                            {isWeeklyRest &&
                                slots_len > 0 &&
                                day?.slots?.map((slot) => {
                                    return renderSlot({
                                        slot,
                                        day_hours_count: slot?.hours_count,
                                        day,
                                    });
                                })}
                            {isLeave && (
                                <StripedTypeLeaveWeek
                                    background_color={
                                        day.type?.leave_color + "50"
                                    }
                                    leave_name={day.type?.leave_name}
                                    striped_color={day.type?.leave_color}
                                    // hours={8}
                                />
                            )}
                            {isWorking &&
                                day?.slots?.map((slot) => {
                                    if (
                                        slot.leave_name !== null &&
                                        slot.shifts.length === 0
                                    ) {
                                        return (
                                            <Flex
                                                styles={{ padding: "2px 4px" }}
                                                fill
                                            >
                                                <StripedTypeLeaveWeek
                                                    background_color={
                                                        slot?.leave_color + "50"
                                                    }
                                                    leave_name={
                                                        slot?.leave_name
                                                    }
                                                    striped_color={
                                                        slot?.leave_color
                                                    }
                                                    // hours={slot?.hours_count}
                                                />
                                            </Flex>
                                        );
                                    }
                                    return renderSlot({
                                        slot,
                                        day_hours_count: slot?.hours_count,
                                        day,
                                    });
                                })}
                            {isWorking && day?.slots?.length === 0 && (
                                <Flex vAlign="center" hAlign="center" fill>
                                    {comment ? (
                                        <Tooltip
                                            position="after"
                                            align="top"
                                            subtle
                                            pointing
                                            content={
                                                <Flex column gap="gap.medium">
                                                    <Flex
                                                        column
                                                        gap="gap.smaller"
                                                    >
                                                        <Flex
                                                            column
                                                            gap="gap.medium"
                                                        >
                                                            <Text
                                                                content={`Commentaire :`}
                                                            />
                                                            <Text
                                                                content={
                                                                    comment
                                                                }
                                                            />
                                                        </Flex>
                                                    </Flex>
                                                </Flex>
                                            }
                                            trigger={
                                                <CellText content={`0 h`} />
                                            }
                                        />
                                    ) : (
                                        <CellText content={`0 h`} />
                                    )}
                                </Flex>
                            )}
                            {isWorking && day?.hours_count === null && (
                                <Flex vAlign="center" hAlign="center" fill>
                                    {comment ? (
                                        <Tooltip
                                            position="after"
                                            align="top"
                                            subtle
                                            pointing
                                            content={
                                                <Flex column gap="gap.medium">
                                                    <Flex
                                                        column
                                                        gap="gap.smaller"
                                                    >
                                                        <Flex
                                                            column
                                                            gap="gap.medium"
                                                        >
                                                            <Text
                                                                content={`Commentaire :`}
                                                            />
                                                            <Text
                                                                content={
                                                                    comment
                                                                }
                                                            />
                                                        </Flex>
                                                    </Flex>
                                                </Flex>
                                            }
                                            trigger={
                                                <CellText content={`0 h`} />
                                            }
                                        />
                                    ) : (
                                        <CellText content={`0 h`} />
                                    )}
                                </Flex>
                            )}
                        </Flex>
                    </OneCell>
                }
            />
        </Flex>
    );
};

export default Cell;

const OneCell = styled(Flex)`
    width: 120px;
    cursor: pointer;

    background-color: ${({ $is_holiday }) =>
        $is_holiday ? "#FBF6D9" : "inherit"};

    &:hover {
        background-color: #f0f0f0;
    }
`;

export const CellText = styled(Text)`
    color: #242424;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
`;

const DialogStyle = styled(Dialog)`
    width: 501px;
`;

const BgIcon = styled(Flex)`
    padding: 8px 8px;
    gap: 8px;
    align-self: stretch;
    background: ${({ bgColor }) => bgColor};
    color: ${({ color }) => color};
    border-radius: 50%;
`;
